module.exports = __webpack_public_path__ + "img/07.40794517.jpg";